import { useMemo } from "react";

import { CancelledException } from "@CORE/exceptions";

import { useApiContext } from "@CONTEXT/hooks";

import { useNotifications } from "@VIEW/hooks";

interface FindAllParams {
    dates: {
        from: string;
        to: string;
    };
}

function createHook() {
    return function useBlockedPeriodsApi() {
        const { api } = useApiContext();

        const { notify } = useNotifications();

        const queries = useMemo(
            () => ({
                findAll: async (params: FindAllParams, signal?: AbortSignal) => {
                    try {
                        return await api.blockedPeriods.findAll(params, signal);
                    } catch (error: unknown) {
                        if (error instanceof Error && !(error instanceof CancelledException)) {
                            notify.error(error.message);
                        }

                        return [];
                    }
                },
            }),
            [api, notify],
        );

        return {
            queries,
        };
    };
}

export const useBlockedPeriodsApi = createHook();
